import { render, staticRenderFns } from "./PlanoAcessorio.vue?vue&type=template&id=728e0060&scoped=true"
import script from "./PlanoAcessorio.vue?vue&type=script&lang=js"
export * from "./PlanoAcessorio.vue?vue&type=script&lang=js"
import style0 from "./PlanoAcessorio.vue?vue&type=style&index=0&id=728e0060&prod&lang=css"
import style1 from "./PlanoAcessorio.vue?vue&type=style&index=1&id=728e0060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728e0060",
  null
  
)

export default component.exports